/**
 * External dependencies.
 */
import React from 'react'
import _ from 'lodash';

/**
 * Internal dependencies.
 */
import PagePlugin from '../../plugin/page-plugin';
import StepDescription from '../../step-description';
import {
	FlexWithPadding,
	SectionWithPadding,
	ContainerWithPadding,
	localize
} from '../../helpers';

class Plugins extends React.Component{
	/**
	 * Sort and filter the plugins before render.
	 */
	beforeRender( items ) {
		// Show the recommended plugins first.
		items = _.orderBy( items, ['is_recommended', 'item_order'], ['desc', 'asc'] )

		items = _.filter( items, this.filterByCategory )
		items = _.filter( items, this.filterVisiblity )

		return items;
	}

	/**
	 * Filter plugins by certain category for current step.
	 */
	filterByCategory = ( plugin ) => {
		// Bail if the type matches, but the category doesn't.
		if ( this.props.step.category && this.props.step.category !== plugin.category ) {
			return;
		}

		return plugin;
	}

	/**
	 * Filter plugins using plugin conditional logic, whether to show them.
	 */
	filterVisiblity = ( plugin ) => {

		// Return the plugin if there is no conditional logic.
		if ( ! plugin.conditional_logic || plugin.conditional_logic.length === 0 ) {
			return plugin;
		}

		for ( var i = 0; i < plugin.conditional_logic.length; i++ ) {
			var item = plugin.conditional_logic[i]

			// Don't show the plugin if any of the conditions fail.
			if (
				( item.item_type === 'plugin' && ! this.props.selectedPlugins.includes( item.item_id ) && item.exists === 1 ) ||
				( item.item_type === 'plugin' && this.props.selectedPlugins.includes( item.item_id ) && item.exists === 0 ) ||
				( item.item_type === 'theme' && this.props.selectedTheme === item.item_id )
			) {
				return false;
			}

		}

		// Finally return the plugin.
		return plugin;
	}

	renderItems() {
		return this.beforeRender( this.props.elements ).map(item => 
			<PagePlugin key={item.id} id={item.id} props{...item}/>
		)
	}

	render() {
        return (
			<SectionWithPadding
				padding={this.props.isPhone? ['none', 'none', 'none', 'none'] : ['small', 'none', 'none', 'none']}
			>
				<StepDescription title={this.props.step.title} subtitle={this.props.step.subtitle} isPhone={this.props.isPhone} />

				<ContainerWithPadding
					padding={this.props.isPhone? ['large','none', 'medium'] : ['large','none', 'none']}
				>
					<FlexWithPadding
						padding={['none','small', 'none']}
						margin="none"
					>

						{ this.renderItems() }
					</FlexWithPadding >

				</ContainerWithPadding>
			</SectionWithPadding>
		);
	}
}

export default Plugins;